module.exports = __webpack_public_path__ + "img/yiwancheng.bf57df6c.svg";